var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "34px",
    viewBox: "0 0 33 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ManHead"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4188473,28.0407157 C21.3165613,34.1954694 26.9767466,34.6891237 30.0592792,29.1424803 C33.1418118,23.5978275 32.4812691,14.1128982 28.582531,7.95814451 C24.683793,1.80438607 19.0246318,1.3117271 15.9410751,6.8563799 C12.8575184,12.402028 13.5190852,21.885962 17.4188473,28.0407157",
    id: "Fill-226",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1649559,28.1347517 C13.9292583,34.2927005 26.1219593,36.2985406 29.0982005,30.7491162 C32.0754305,25.1996918 27.0415289,14.1207619 23.2782153,7.96281305 C19.5139129,1.80386823 14.0489012,1.30987783 11.07266,6.85930224 C8.09543001,12.4087266 6.40065346,21.9758068 10.1649559,28.1347517",
    id: "Fill-227",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3533129,10.0933963 C14.3533129,10.0933963 18.2184302,23.1144533 8.36093712,28 C8.36093712,28 -4.58187757,23.2860886 1.73914773,8.91012273 C7.31025464,-3.76059653 21,2.59293624 21,2.59293624 L14.3533129,10.0933963",
    id: "Fill-228",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9069342,17 C31.9069342,17 29.4424415,11.4815745 22,10.3105342 L26.9259252,6 C26.9259252,6 32.803577,6.26921645 31.9069342,17",
    id: "Fill-229",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2435349,19 C12.9533554,15.5229115 17.7914261,14.6770256 25.1087858,15.9189851 C26.2229842,16.1090606 27.3836076,16.0811962 28.430638,15.6582532 C33.3487176,13.6669384 32.9753426,7.14267038 32.9753426,7.14267038 C33.3121703,2.67539781 30.1621892,1.25729502 25.7281142,0.917945511 L14.1771956,0.0322532441 C7.63621884,-0.504137915 2.51564746,5.76536914 2.17881975,10.2336369 L2.0158386,10.9889632 C1.67802313,15.4572309 6.80847216,18.6596553 11.2435349,19",
    id: "Fill-230",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44584116,27.5726562 C8.31380476,28.9829798 10.1613943,29.4230608 11.5726562,28.5541588 C12.9829798,27.6852569 13.4230608,25.8386057 12.5541588,24.4273438 C11.6852569,23.0170202 9.83766735,22.5769392 8.42734378,23.4458412 C7.01702022,24.3147431 6.57693921,26.1613943 7.44584116,27.5726562",
    id: "Fill-231",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,30.8817383 L25.5,30.8817383 C26.8810843,30.3494159 28,28.1624987 28,26 L23,27.9310117 C23,30.0944872 24.119905,31.4150375 25.5,30.8817383",
    id: "Fill-233",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHead);
export default __webpack_public_path__ + "static/media/ManHead.d3232a04199cfcb9a66d0b10051167a6.svg";
export { ForwardRef as ReactComponent };